import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { touchProjectPermission } from 'redux/modules/projects.types';
import { getUserId } from 'redux/selectors/user';
import type { ThunkDispatch } from 'types/redux';

/**
 * Moves projects to the top of "Recent" in every project picker, the same way
 * saving an Hour does. Rails records the same use on the assignment, so the
 * order survives a reload. The last id passed ends up first.
 *
 * Only projects already in the user's permission list move. Unlike saving an
 * Hour, assigning on Agent Tracking never makes the user a project member, and
 * Rails only records the use on an existing membership, so inserting one here
 * would show a Recent entry that disappears on reload.
 */
export function useMarkProjectsUsed() {
  const dispatch = useDispatch<ThunkDispatch>();
  const userId = useSelector(getUserId);
  return useCallback(
    (projectIds: number[]) => {
      if (!userId) return;
      for (const projectId of projectIds) dispatch(touchProjectPermission({ userId, projectId }));
    },
    [dispatch, userId]
  );
}
